import Vue from 'vue'
import 'babel-polyfill'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
//引入Element的语言包
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

import 'animate.css'
import 'vue-fullpage/vue-fullpage.css'
import './assets/iconfont/iconfont.css'
import VueFullpage from 'vue-fullpage'
import VueNumberAnimate from 'vue-animate-number'
import App from './App.vue'
import router from './router'
// 引入组件和样式
import RouterTab from 'vue-router-tab'
import 'vue-router-tab/dist/lib/vue-router-tab.css'
import ApiUrl from './config/api.js'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import global_ from './components/Global'
Vue.prototype.api = ApiUrl
Vue.prototype.GLOBAL = global_

// 引入高德地图
import VueAMap from 'vue-amap'

Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'a56b45aaaf16ffa17bbe3d1c1b7cd969',
  plugin: ['Autocomplete', 'PlaceSearch', 'Scale', 'OverView', 'ToolBar', 'MapType', 'PolyEditor', 'AMap.CircleEditor', 'Geolocation', 'Geocoder', 'MarkerClusterer', 'ElasticMarker', 'Heatmap'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
  uiVersion: '1.0.11'
})
window._AMapSecurityConfig = {
  securityJsCode: 'cc4d84dc0dcc23c67d481e164bd3f966',
}

import VueResource from 'vue-resource'
Vue.use(VueResource)
Vue.config.productionTip = false
Vue.use(RouterTab)

Vue.use(VueFullpage)
Vue.use(VueNumberAnimate)
import VueParticles from 'vue-particles'
Vue.use(VueParticles)
import ZwToolBar from './lib/zw-toolbar'
Vue.use(ZwToolBar)
import moment from 'moment'
Vue.prototype.$moment = moment

import axios from 'axios'

Vue.prototype.axios = axios

import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(Mint)

Vue.use(VueI18n)
import store from './store/index'
/*Vue.prototype.axios.get(Vue.prototype.api.ApiUrl.i18nlist).then((result)=>{
  var i18nListData = result.data
  if(i18nListData.code==20000){
    i18n.setLocaleMessage('en',Object.assign(i18nListData.data.en, zhLocale));
    i18n.setLocaleMessage('zh',Object.assign(i18nListData.data.zh, zhLocale));
  }else{
    i18n.setLocaleMessage('en',Object.assign(zhLocale));
    i18n.setLocaleMessage('zh',Object.assign(zhLocale));
  }
})*/
const i18n = new VueI18n({
  locale: 'en',
  // locale: sessionStorage.getItem('language')||'en',
  messages: {
    en: {
      message: 'hello',
      ...enLocale // 或者用 Object.assign({ message: 'hello' }, enLocale)
    },
    zh: {
      message: '你好',
      ...zhLocale // 或者用 Object.assign({ message: '你好' }, zhLocale)
    }
  },
})
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value) //重点！！在注册Element时设置i18n的处理方法（这里有个小坑）
})

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'ttlkNFrO2pvCLISsjSqEEcWV4SfUheR2'
})
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
Vue.component('v-chart', ECharts)
import './styles/iconfont.css'


// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCMpZbh69zk5oYDm16zUAzccHnFSI6pRVA',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    language: 'en',
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
  loadCn: false
})

// import vGoogleTranslate from "v-google-translate";
// Vue.use(vGoogleTranslate);

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})





// WEBPACK FOOTER //
// ./src/main.js